import { RootState } from "@/redux/store";

export const subscriptionExpiredSelector = (state: RootState) => state.ui.subscriptionExpired;
